import { render, staticRenderFns } from "./effect-preview.vue?vue&type=template&id=c0b64458&scoped=true"
import script from "./effect-preview.vue?vue&type=script&lang=js"
export * from "./effect-preview.vue?vue&type=script&lang=js"
import style0 from "./effect-preview.vue?vue&type=style&index=0&id=c0b64458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b64458",
  null
  
)

export default component.exports